import { useState } from "react";
import { FlaskConical } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const NOTICE = "Greenwick Terminal is a simulated trading platform. All trades use virtual money and are never sent to any stock exchange. You cannot make or lose real money from trades on this platform.";
export const BADGE = "SIMULATED TRADING – virtual money, no real orders";
export const RECORD = "SIMULATED – not a real trade record";
export const SIM_ORDER = "Simulated order";

export function SimBadge({ className = "", testid = "sim-badge" }) {
  return (
    <span data-testid={testid} title={NOTICE} aria-label={BADGE}
      className={`inline-flex items-center gap-1.5 rounded-full border border-amber-500/60 bg-amber-500/15 px-2.5 py-0.5 text-[10px] font-bold tracking-[0.08em] text-amber-600 dark:text-amber-400 whitespace-nowrap select-none ${className}`}>
      <FlaskConical className="h-3 w-3 shrink-0" />
    </span>
  );
}

export function SimLabel({ text = SIM_ORDER, testid, className = "" }) {
  return <span data-testid={testid} className={`text-[10px] font-semibold uppercase tracking-[0.12em] text-amber-600 dark:text-amber-400 ${className}`}>{text}</span>;
}

export function NoticeText({ className = "", testid = "sim-notice-text", boxed = false }) {
  const look = boxed ? "rounded-lg border border-amber-500/40 bg-amber-500/10 p-3 text-[11.5px] text-amber-700 dark:text-amber-300" : "text-[10.5px] text-muted-foreground";
  return <p data-testid={testid} className={`leading-relaxed ${look} ${className}`}>{NOTICE}</p>;
}

export function DisclosureGate() {
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  if (!user || user.disclosure_accepted) return null;
  const accept = async () => {
    setBusy(true); setErr("");
    try { const { data } = await api.post("/disclosure/accept", { source: "terminal" }); setUser({ ...user, ...data }); } catch (e) { setErr(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div data-testid="disclosure-gate" role="dialog" aria-modal="true" className="fixed inset-0 z-[200] grid place-items-center bg-black/85 p-4 backdrop-blur-md">
      <div className="w-full max-w-md rounded-2xl border border-amber-500/40 bg-card p-7 shadow-2xl page-in">
        <SimBadge testid="disclosure-gate-badge" />
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight">Before you start</h2>
        <NoticeText boxed className="mt-4 text-[13px]" testid="disclosure-gate-text" />
        {err && <p data-testid="disclosure-gate-error" className="mt-3 text-[12px] text-down">{err}</p>}
        <button data-testid="disclosure-accept-button" onClick={accept} disabled={busy}
          className="mt-6 h-11 w-full rounded-lg bg-gold text-[13px] font-semibold tracking-wide text-[#0b0b0d] shadow-gold transition-[filter] duration-150 hover:brightness-110 disabled:opacity-60">
          {busy ? "Saving…" : "I understand and accept"}
        </button>
      </div>
    </div>
  );
}
